import feedsApi from 'common/src/modules/feeds/feeds.api';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {CampaignSetupAgentToolName} from '../../campaignSetupAgent.enums';

const getProductFeedColumnsToolSchema = z.object({
  productFeedId: z.number().describe('The product feed id'),
});

export default function getProductFeedColumnsTool() {
  async function execute({
    input: {productFeedId},
  }: ToolExecuteParams<typeof getProductFeedColumnsToolSchema>): Promise<ToolResult> {
    try {
      const signals = await feedsApi.getSupportedSignals(productFeedId);

      const formattedColumns = signals.map((signal) => ({
        name: signal.name,
        value: signal.value,
        type: signal.type,
        description: signal.description || '',
        optionalOperators: signal.optionalOperators || [],
      }));

      const response = {
        columns: formattedColumns,
        totalCount: formattedColumns.length,
        productFeedId,
        instructions:
          formattedColumns.length > 0
            ? `Found ${formattedColumns.length} available columns for product feed configuration.`
            : `No columns found for product feed configuration.`,
      };

      return toolResult(JSON.stringify(response));
    } catch (error) {
      return toolResult(
        `Error retrieving product feed columns: ${
          error instanceof Error ? error.message : 'Unknown error'
        }`,
      );
    }
  }

  return tool({
    name: CampaignSetupAgentToolName.GetProductFeedColumns,
    displayName: 'Getting product feed columns',
    description: 'Get the matching feed column for the product feed based on the feed column name',
    execute,
    inputSchema: getProductFeedColumnsToolSchema,
  });
}
